<template>
    <div class="container">
        <template v-if="loading">
            <a-spin size="large" class="loading" />
        </template>
        <template v-else>
            <div class="toolbar">
                <div class="left-items">
                    <a-button class="item" @click="load" icon="icon icon-reset" style="margin-right:8px"></a-button>
                    <a-button
                        class="item"
                        @click="visible_edit = true"
                        style="margin-right:8px"
                        icon="edit"
                        v-if="permissible.indexOf('order_trademark.edit') > -1"
                    >
                        修改订单资料
                    </a-button>
                    <a-button
                        class="item"
                        icon="user"
                        @click="on_distribute([data_source])"
                        v-if="permissible.indexOf('order_trademark.distribute') > -1"
                        >修改订单销售</a-button
                    >

                  <a-button
                      class="item"
                      @click="visible_express = true"
                      style="margin-right:8px"
                      icon="mail"
                  >
                    添加快递信息
                  </a-button>
<!--                    <a-button
                        class="item"
                        icon="pay-circle"
                        @click="on_update_price"
                        v-if="permissible.indexOf('order_trademark.update_price') > -1"
                        >修改订单金额</a-button
                    >-->

                    <a-button
                        class="item"
                        icon="close"
                        @click="on_cancel"
                        :disabled="data_source.recharge_status > 1"
                        v-if="permissible.indexOf('order_trademark.cancel') > -1"
                        >取消并结束订单</a-button>
                </div>

                <div class="right-items"></div>
            </div>

            <!-- 主体部分 -->
            <div class="main">
                <div class="description">
                    <a-row v-if="visible_detail">
                        <a-col :span="12">
                            <a-card title="订单信息" class="infobox order" :bordered="false">
                                <a-descriptions size="small" :column="2" bordered>
                                    <a-descriptions-item label="订单号">
                                        {{ data_source.order_no }}
                                    </a-descriptions-item>

                                    <a-descriptions-item label="订单金额"> ¥{{ data_source.amount }} </a-descriptions-item>
                                    <a-descriptions-item label="下单时间">
                                        {{ moment(data_source.created_at * 1000).format("MM-DD HH:mm") }}
                                    </a-descriptions-item>
                                    <a-descriptions-item label="首付款"
                                        >¥{{ data_source.amount_deposit }}
                                        <small
                                            >（{{
                                                data_transaction.deposit
                                                    ? data_transaction.deposit.audit_status == 1
                                                        ? "申请中"
                                                        : "已通过"
                                                    : "待处理"
                                            }}）</small
                                        ></a-descriptions-item
                                    >

                                    <a-descriptions-item label="是否包含发票">
                                        {{ data_source.is_include_invoice ? "是" : "-" }}
                                    </a-descriptions-item>
                                    <a-descriptions-item label="尾款金额"
                                        >¥{{ data_source.amount_retainage }}
                                        <small
                                            >（{{
                                                data_transaction.retainage
                                                    ? data_transaction.retainage.audit_status == 1
                                                        ? "申请中"
                                                        : "已通过"
                                                    : "待处理"
                                            }}）</small
                                        ></a-descriptions-item
                                    >

                                    <a-descriptions-item label="是否包含公证">
                                        {{ data_source.is_include_notary ? "是" : "-" }}
                                    </a-descriptions-item>
                                  <a-descriptions-item label="跟进销售" :span="2"
                                  >{{ data_source.user.name }} （{{ data_source.user.group.name }}）</a-descriptions-item
                                  >
                                    <a-descriptions-item label="是否包含转让">
                                        {{ data_source.is_include_transfer ? "是" : "-" }}
                                    </a-descriptions-item>

                                    <a-descriptions-item label="订单备注">
                                        {{ data_source.remark || "无" }}
                                    </a-descriptions-item>
                                </a-descriptions>
                            </a-card>

                          <a-col :span="24">
                            <a-card title="快递信息" class="infobox order" :bordered="false">
                              <a-descriptions size="small" :column="2" bordered>
                                <a-descriptions-item label="收件人">
                                  {{ data_source.userName || "无" }}
                                </a-descriptions-item>

                                <a-descriptions-item label="收件人号码">
                                  {{ data_source.mobile || "无" }}
                                </a-descriptions-item>

                                <a-descriptions-item label="快递地址">
                                  {{ data_source.address || "无" }}
                                </a-descriptions-item>

                                <a-descriptions-item label="快递单号">
                                  {{ data_source.express || "无" }}
                                </a-descriptions-item>
                              </a-descriptions>
                            </a-card>
                          </a-col>
                        </a-col>
                        <a-col :span="12">
                            <a-row>
                                <a-col :span="24">
                                    <a-card title="商标信息" class="infobox trademark" :bordered="false">
                                        <template v-if="data_source.trademark">
                                            <a-row :gutter="12">
                                                <a-col :span="12"
                                                    ><div class="thumb"><img :src="data_source.trademark.logo" /></div
                                                ></a-col>
                                                <a-col :span="12">
                                                    <div class="name">
                                                        {{ data_source.trademark.markName || "-" }}
                                                    </div>
                                                    <div class="apply-no">NO：{{ data_source.apply_no }}</div>

                                                    <!-- <div class="lm">
                                                        {{ data_source.trademark.internationalGroup }}类
                                                        {{ data_source.trademark.type_text }}
                                                    </div> -->

                                                    <div class="price">¥{{ data_source.trademark.price }}</div>
                                                </a-col>
                                            </a-row>
                                        </template>
                                    </a-card>
                                </a-col>

                                <a-col :span="12">
                                    <a-card title="买家信息" class="infobox user" :bordered="false">
                                        <template v-if="data_source.member">
                                            <a-descriptions size="small" :column="1">
                                                <a-descriptions-item label="姓名">
                                                    {{ data_source.member.name }} <small>(ID:{{ data_source.member_id }})</small>
                                                </a-descriptions-item>
                                                <a-descriptions-item label="电话">
                                                    {{ data_source.member.mobile }}
                                                </a-descriptions-item>
                                                <a-descriptions-item label="公司">
                                                    {{ data_source.member.com_name || "-" }}
                                                </a-descriptions-item>
                                            </a-descriptions>
                                        </template>
                                    </a-card>
                                </a-col>
                              <a-col :span="12">
                                    <a-card title="收款信息" class="infobox user" :bordered="false">
                                        <template>
                                            <a-descriptions size="small" :column="1">
                                                <a-descriptions-item label="订单金额">
                                                    {{ data_source.amount }}
                                                </a-descriptions-item>
                                                <a-descriptions-item label="首付款">
                                                    {{ data_source.amount_deposit }}
                                                </a-descriptions-item>
                                                <a-descriptions-item label="尾款金额">
                                                    {{ data_source.amount_retainage || "-" }}
                                                </a-descriptions-item>
                                            </a-descriptions>
                                        </template>
                                    </a-card>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>

                </div>

                <div class="cancel-msg" v-if="data_source.status == '-1' && data_source.cancel_msg">
                    <a-icon type="exclamation-circle" style="margin-right:2px;" />
                    {{ data_source.cancel_msg }}
                </div>

                <div class="steps">
                    <a-steps :current="data_source.step_digit">
                        <a-step title="已发起" status="finish" />
                        <a-step title="已首款" :status="data_source.recharge_status >1 && data_source.recharge_status != 3  ? 'finish' : 'wait'" />
                        <a-step
                            title="已尾款"
                            :status="data_source.recharge_status === 5 ? 'finish' : 'wait'"
                        />
                        <a-step
                            title="已完成"
                            :status="data_source.recharge_status === 5 ? 'finish' : 'wait'"
                        />
                    </a-steps>
                </div>

                <div class="detail">
                    <a-row :gutter="48">
                        <a-col :sm="24" :md="24" :xs="12" :lg="12" :xl="12" :xxl="12">
                            <div class="progress">
                                <a-card class="step"
                                        :title="data_source.recharge_status  == 0 ? '提交首付款申请' :
                                                data_source.recharge_status  == 2 ? '提交尾款申请' : null "
                                        v-if="
                                        data_source.recharge_status  == 0
                                        || data_source.recharge_status  == 2
                                        || data_source.recharge_status  == 3"
                                        hoverable>
<!--                                    <a-icon type="check-circle" slot="extra" class="status-icon"  />-->

                                    <template>

                                      <a-form-model :model="form" ref="recharge-create" :rules="rules">
                                        <a-form-model-item :label="data_source.recharge_status  == 2 ? '尾款金额' : '首款金额'">
                                          <a-input v-model="data_source.recharge_status  == 2 ?
                                           data_source.amount - data_source.amount_deposit :
                                            data_source.amount_deposit" disabled></a-input>
                                        </a-form-model-item>

                                        <a-form-model-item label="充值时间" prop="paid_at" extra="填写客户的实际充值时间，以便财务审核">
                                          <a-date-picker show-time v-model="form.paid_at" style="width:100%" valueFormat="YYYY-MM-DD HH:mm" />
                                        </a-form-model-item>

                                        <a-form-model-item label="收款渠道" prop="payment_id">
                                          <a-select
                                              class="spotlight"
                                              show-search
                                              :show-arrow="false"
                                              :dropdownMatchSelectWidth="false"
                                              placeholder="选择收款渠道"
                                              :filter-option="false"
                                              @search="on_membersearch"
                                              style="transition:0.2s width"
                                              option-label-prop="value"
                                              v-model="form.payment_id"
                                          >
                                            <a-spin v-if="loading_member" slot="notFoundContent" size="small" />

                                            <a-select-opt-group v-for="d in data_member" :key="d.name">
                                              <a-select-option :value="d.name"  :key="d.id" :name="d.name" :item="d">
                                                <div>
                                                  银行名称：{{ d.bank }}，账号：{{ d.account }}
                                                </div>
                                              </a-select-option>

                                            </a-select-opt-group>
                                          </a-select>
                                        </a-form-model-item>

                                        <a-form-model-item label="充值截图" prop="screenshot">
                                          <a-upload
                                              list-type="picture-card"
                                              name="file"
                                              :action="action"
                                              :withCredentials="true"
                                              :show-upload-list="false"
                                              @change="(info) => on_upload_change(info, 'screenshot')"
                                              accept="image/png, image/jpeg"
                                          >
                                            <img v-if="form.screenshot" :src="form.screenshot" style="width:100%" />

                                            <div v-else>
                                              <a-icon :type="uploading ? 'loading' : 'plus'" />
                                              <div class="ant-upload-text">
                                                上传
                                              </div>
                                            </div>
                                          </a-upload>
                                        </a-form-model-item>

                                        <a-form-model-item label="备注">
                                          <a-textarea v-model="form.memo"></a-textarea>
                                        </a-form-model-item>

                                      </a-form-model>

                                    </template>

                                    <div class="complete">
                                        <a-button
                                            type="primary"
                                            @click="on_submit(data_source.recharge_status  == 2 ? 2 : 1)"
                                            v-if="data_source.step_digit <= 1"
                                        >
                                            提交
                                        </a-button>
                                        <div class="result" v-if="data_progress && data_progress['deposit']">
                                            {{ data_progress["contract"]["user"]["name"] }} 完成于
                                            {{ moment(data_progress["contract"]["created_at"]).format("YYYY-MM-DD HH:mm") }}
                                        </div>
                                    </div>
                                </a-card>

<!--                              财务审批过程中-->
                              <a-card class="step" title="流程" hoverable>
                                <template>
                                  <a-timeline>
                                    <a-timeline-item>{{ moment(data_source.created_at * 1000).format("YYYY-MM-DD HH:mm") }} 发起订单</a-timeline-item>
                                    <a-timeline-item v-for="datas in data_source.finance">
                                      {{ moment(datas.created_at * 1000).format("YYYY-MM-DD HH:mm") }}
                                      {{datas.type == 1 ? '提交了首付款审批' : '提交了尾款审批'}}
                                      <img v-if="datas.screenshot" :src="datas.screenshot" style="width:100%" />
                                      <template v-if="datas.type == 1 && datas.status == 1">
                                        <a-alert message="首付款财务审批中..." type="success" />
                                      </template>
                                      <template v-if="datas.type == 1 && datas.status == 2">
                                        <a-alert :message='moment(datas.updated_at * 1000).format("YYYY-MM-DD HH:mm") + "首付款财务审核成功"' type="success" />
                                      </template>
                                      <template v-if="datas.type == 1 && datas.status == 3">
                                        <a-alert :message='moment(datas.updated_at * 1000).format("YYYY-MM-DD HH:mm") + "首付款财务审核失败"' type="success" />
                                      </template>
                                      <template v-if="datas.type == 2 && datas.status == 1">
                                        <a-alert message="尾款财务审批中..." type="success" />
                                      </template>
                                      <template v-if="datas.type == 2 && datas.status == 2">
                                        <a-alert :message='moment(datas.updated_at * 1000).format("YYYY-MM-DD HH:mm") + "尾款财务审核成功"' type="success" />
                                      </template>
                                      <template v-if="datas.type == 2 && datas.status == 3">
                                        <a-alert :message='moment(datas.updated_at * 1000).format("YYYY-MM-DD HH:mm") + "尾款财务审核失败"' type="success" />
                                      </template>

                                    </a-timeline-item>
                                    <a-timeline-item v-if="data_source.recharge_status == 1">首付款等待财务审批中...</a-timeline-item>
                                    <a-timeline-item v-if="data_source.recharge_status == 2">首付款财务审核成功</a-timeline-item>
                                    <a-timeline-item v-if="data_source.recharge_status == 3">首付款财务审核失败</a-timeline-item>
                                    <a-timeline-item v-if="data_source.recharge_status == 4">尾款财务审批中</a-timeline-item>
                                    <a-timeline-item v-if="data_source.recharge_status == 5">尾款财务审批成功</a-timeline-item>
                                    <a-timeline-item v-if="data_source.recharge_status == 6">尾款审批失败</a-timeline-item>
                                  </a-timeline>
                                </template>
                                <a-icon type="check-circle" slot="extra" class="status-icon" v-if="data_source.step_digit > 3" />
                              </a-card>

                            </div>
                        </a-col>
                    </a-row>
                </div>
            </div>
        </template>

        <!-- 取消订单 -->
        <modal_cancel :visible="visible_cancel" @close="visible_cancel = false" :record="data_source" :callback="load" />

        <!-- 修改订单金额 -->
        <modal_price :visible="visible_price" :callback="load" @close="visible_price = false" :record="data_source" />

        <!-- 订单修改 -->
        <modal_edit :visible="visible_edit" :callback="load" @close="visible_edit = false" :record="data_source" />

      <!-- 添加快递信息 -->
      <modal_express :visible="visible_express" :callback="load" @close="visible_express = false" :record="data_source" />
    </div>
</template>

<script>
import env from "../../../../env";

let init_form = {
  amount: null,
  member_id: null,
  payment_id: null,
  memo: null,
  screenshot: null,
};
    import moment from "moment";
    import modal_cancel from "../components/modal_cancel.vue";
    import modal_edit from "../components/modal_edit";
    import modal_express from "../components/modal_express";
    import modal_price from "../components/modal_price";

    import common from "../mixins/common";
    export default {
        mixins: [common],
        data() {
            return {
              loading_member: false,
              loading: false,
                order_no: null,
                data_source: {},
                visible_detail: true,
                step: 1,
                comment_content: null,
                data_contract: [],
                data_transaction: {},
                data_progress: null,
                visible_loading: false,
                visible_participant: false,
                visible_resource_deduct: false,
                visible_recharge_apply: false,
                visible_cancel: false,
                visible_edit: false,
              visible_express: false,
                visible_contract: false,
                visible_balance_deduct: false,
                visible_resource: false,
                visible_price: false,
                visible_loan: false,
                upload_type: null,
                loading_file: false,
                loan_type: null,
              action: env.base_url + "service/upload",
              submitting: false,
              uploading: false,
              callback: null,
              rules: {
                member_id: [
                  {
                    required: true,
                    trigger: ["change", "blur"],
                    message: "必填",
                  },
                ],
                payment_id: [
                  {
                    required: true,
                    trigger: ["change", "blur"],
                    message: "必填",
                  },
                ],
                screenshot: [
                  {
                    required: true,
                    trigger: ["change", "blur"],
                    message: "必填",
                  },
                ],
                paid_at: [
                  {
                    required: true,
                    trigger: ["change", "blur"],
                    message: "必填",
                  },
                ],
              },
              form: null,
            };

        },
        components: {
            modal_cancel,
            modal_edit,
          modal_express,
            modal_price,
        },
        created() {
            this.order_no = this.$route.params.order_no;
            this.load();
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        methods: {
            moment,
            load() {
                this.on_membersearch(1);
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/order_trademark/${this.order_no}?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.get_progress();

                            this.load_transaction();
                        } else {
                            this.$error({
                                type: "error",
                                title: "失败",
                                content: res.message,
                                centered: true,
                                onOk: () => {
                                    this.$router.replace("/order");
                                },
                            });
                        }
                    })
                    .catch((e) => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_deposit_deduct() {
                this.visible_resource_deduct = true;
            },
            on_cancel() {
                this.visible_cancel = true;
            },
            on_recharge_apply() {
                this.visible_recharge_apply = true;
            },
            load_transaction() {
                this.$http
                    .get(`/order_trademark/transaction/${this.order_no}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_transaction = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            get_progress() {
                this.$http
                    .get(`/order_trademark/${this.order_no}/progress`)
                    .then((res) => {
                        if (res.success) {
                            let result = {};
                            res.data.map((v) => {
                                result[v.step] = v;
                            });
                            this.data_progress = result;
                        } else {
                            this.data_progress = null;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_complete(step) {
                this.$confirm({
                    centered: true,
                    title: "是否已经完成了该流程？",
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .post("/order_trademark/progress", { step: step, order_no: this.order_no })
                                .then((res) => {
                                    if (!res.success) {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
          on_submit(type) {
            this.$refs["recharge-create"].validate((valid) => {
              if (valid) {
                this.submitting = true;
                this.$http
                    .post("/order_trademark/recharge",
                        {
                          type: type,//1首付款 2尾款
                          order_no: this.order_no,
                          screenshot:this.form.screenshot,
                          memo:this.form.memo,
                          paid_at:this.form.paid_at,
                          payment_id:this.form.payment_id,
                        })
                    .then((res) => {
                      if (res.success) {
                        this.$message.success(res.message);
                        this.load();
                      } else {
                        this.$error({ title: "失败", centered: true, content: res.message });
                      }
                    })
                    .catch(() => {})
                    .then(() => {
                      this.submitting = false;
                    });
              } else {
                this.$message.error("请检查并填写完需要录入的内容");
                return false;
              }
            });
          },
            on_complete_contract() {
                this.$confirm({
                    centered: true,
                    title: "是否完成本次订单的合同签署",
                    content: "请确保本次订单所关联的合同，已经签署完成，并且归档。",
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .post("/order_trademark/progress", { step: "contract", order_no: this.data_source.order_no })
                                .then((res) => {
                                    if (!res.success) {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_balance_deduct() {
                this.visible_balance_deduct = true;
            },
            on_update_price() {
                this.visible_price = true;
            },
            on_deposit_seller_apply() {
                this.visible_loan = true;
                this.loan_type = "deposit";
            },
            on_retainage_seller_apply() {
                this.visible_loan = true;
                this.loan_type = "retainage";
            },
          on_upload_change(info, field) {
            if (info.file.status === "uploading") {
              this.uploading = true;
              return;
            }
            if (info.file.status === "done") {
              this.uploading = false;
              if (info.file.response.success) {
                this.form[field] = info.file.response.data.url;
              } else {
                this.$error({
                  title: "失败",
                  content: info.file.response.message,
                });
              }
            } else if (info.file.status === "error") {
              this.$message.error(`${info.file.name} 上传失败.`);
            }
          },
          on_membersearch(v) {
            this.loading_member = true;
            this.$http
                .get(`/member/accessible?type=payment&wd=${v}`)
                .then((response) => {
                  if (response.success) {
                    this.data_member = response.data;
                  }
                })
                .catch(() => {})
                .then(() => {
                  this.loading_member = false;
                });
          },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .loading {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -16px;
            margin-right: -16px;
        }
        .complete-icon {
            position: absolute;
            right: 40px;
            top: 120px;
            .anticon {
                font-size: 100px;
                &.success {
                    color: #52c41a;
                }
                &.fail {
                    color: #f5222d;
                }
            }
        }
        .toolbar {
            background-color: #fafafa;
            .title {
                font-size: 18px;
                color: #000;
            }
        }

        .secondary {
            opacity: 0.6;
            color: #ff5722;
        }
        .header {
            border-bottom: 1px solid rgb(235, 237, 240);
        }
        .main {
            padding: 0;
            padding-top: 0;
            top: 57px;
            padding-bottom: 48px;
            .description {
                border-bottom: 1px solid #e8e8e8;
                position: relative;
                .toggle {
                    position: absolute;
                    bottom: -12px;
                    left: 50%;
                    margin-left: -12px;
                }
                .hide-detail {
                    width: 100%;
                    height: 5px;
                    background: #f0f0f0;
                    margin: 16px 0;
                }
                .order {
                    /deep/.ant-descriptions-item-label {
                        width: 125px;
                    }
                }
                .user {
                    /deep/.ant-descriptions-item-label {
                        width: 75px;
                    }
                }
                .extra {
                    font-size: 16px;
                    .complete {
                        color: green;
                    }
                    .pending {
                        color: gray;
                    }
                    .cancel {
                        color: red;
                    }
                }
                .infobox {
                    position: relative;
                    &.trademark {
                        .thumb {
                            max-height: 100px;
                            overflow: hidden;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            img {
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: contain;
                            }
                        }

                        .name {
                            font-size: 16px;
                            margin: 8px 0;
                        }
                        .apply-no {
                            font-size: 12px;
                            color: #00000073;
                        }
                        .price {
                            font-size: 16px;
                            color: #ff4d4f;
                        }
                    }
                }
            }
            .cancel-msg {
                color: #ff9800;
                padding: 12px 16px 0;
            }
            .steps {
                border-bottom: 1px solid #ebedf0;
                width: 100%;
                background: #fafafa;
                .ant-steps {
                    max-width: 1024px;
                    margin: 0 auto;
                    padding-top: 24px;
                    padding-bottom: 24px;
                }
            }
            .detail {
                margin: 24px 24px 0px;
                .progress {
                    .step {
                        margin-bottom: 24px;
                        .status-icon {
                            color: green;
                            font-size: 20px;
                        }
                        .complete {
                            margin-top: 24px;
                            .result {
                                color: green;
                            }
                        }
                        .action {
                            margin-top: 24px;
                            .ant-btn {
                                margin-right: 12px;
                            }
                        }
                        .tips {
                            color: #9e9e9e;
                            .anticon {
                                margin-right: 4px;
                            }
                        }
                    }
                    .contract {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .left {
                            .sign {
                                .item {
                                    padding: 0;
                                    color: #00000073;
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }

                .ant-descriptions {
                    /deep/.ant-descriptions-item-label {
                        width: 150px;
                    }
                }
            }
        }
    }
</style>
